<template>
    <div class="detail core-technology-container">
        <div class="technology-main">
            <div class="detail_container">
                <div class="detail_left">
                    <div v-if="JSON.stringify(currentDeatil)!='{}'">
                        <div class="des_one_row" style="height: 34px; font-size: 24px;color: #fff;font-weight: 500;">
                            {{ currentDeatil.title }}
                        </div>
                        <div style="margin: 13px 0px 27px;">
                            <img src="@/assets/image/clock.svg" alt="">
                            <span style="color: #fff; font-size: 12px;margin-left:4px ;opacity: 80%;">{{$t('personalCenter.releaseTime')}}：{{
                                handledate(currentDeatil.updateTime) }}</span>
                        </div>
                        <div class="content">
                            <el-scrollbar>
                                <div class="contendetail" style="min-height: 867px; color: rgba(255, 255, 255, 0.8);  font-size: 14px;word-wrap: break-word;line-height: 200%;"
                                    v-html="currentDeatil.contentDetail"></div>
                            </el-scrollbar>

                        </div>
                    </div>
                    <div v-else>
                        <el-empty :image="require('@/assets/image/empty@3x.png')" :image-size="220" description="暂无文章内容，看看其他内容吧" />
                    </div>
                    <!-- <div>
                        <el-divider />
                        
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { getplatdocumentByid, getsolutiondocumentByid } from "@/api/developer"
import { useRoute } from 'vue-router';
import {handledate} from '@/utils/common.js'
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

let currentDeatil = ref({})
const route = useRoute();
onBeforeMount(() => {
    let { id, type } = route.query
    if (type == 'plat') {
        getDocumentBId(id)
    } else {
        getsolutiondetailByid(id)
    }
})
const getsolutiondetailByid = (id) => {
    getsolutiondocumentByid({ solutionId: id }).then(res => {
        if (res.code === 200) {
            currentDeatil.value = res.result
            console.log(currentDeatil);
        }
        console.log(res);
    }).catch(err => { console.log(err); })
}
const getDocumentBId = (id) => {
    getplatdocumentByid({ platformFunctionId: id }).then(res => {
        if (res.code === 200) {
            currentDeatil.value = res.result
            console.log(currentDeatil);
        }
        console.log(res);
    }).catch(err => { console.log(err); })
}
</script>

<style lang="scss" scoped>
.core-technology-container {
    min-height: calc(100vh - 56px);
    background-color: #111;
    .technology-main {
        padding: 24px 0 40px;
    }
}
p {
    word-wrap: break-word;
}
::v-deep .detail_left img {
    max-width: 1056px;
}
::v-deep .detail_left  video{
   max-width: 1056px;
}
::v-deep .el-empty {
    padding-top: 345px;
    p{
        font-size: 16px;
        color: #ffffff48;
        transform: translateY(-30px);
    }
}
.des_one_row {
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -webkit-ellipsis-lastline;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}
@media (min-width: 1200px) {
    .detail_container {
        width: 1105px;
        .contendetail {
            width: 1057px;
        }
    }
}

@media (max-width: 1200px) {
    .detail_container {
        width: calc(100vw - 80px);

        .contendetail {
            width: calc(100vw - 123px);
        }
    }
}

.detail_container {
    margin: 0 auto;
    display: flex;
    border-radius: 4px;
    justify-content: space-between;

    .detail_left {
        flex: 1;
        padding: 32px 24px 47px;
        background-color: #1f1f1f;
        border-radius: 4px;
        // ::v-deep .el-divider--horizontal {
        //     border-top: none;
        //     background-color: rgba($color: #fff, $alpha: 0.2);
        //     margin: 0px 0px 40px;
        // }
    }

    // .detail_right {
    //     width: 226px;
    //     background-color: #232323;
    //     padding: 32px 27px 32px 23px;

    //     .news_card {
    //         cursor: pointer;
    //             .card_title {
    //             font-size: 12px;
    //             color: #fff;
    //             margin: 14px 0px;
    //         }

    //         .card_content {
    //             font-size: 12px;
    //             color: #fff;
    //             opacity: 80%;
    //         }

    //         ::v-deep .el-divider--horizontal {
    //             border-top: none;
    //             background-color: rgba($color: #fff, $alpha: 0.2);
    //             margin: 0px;
    //         }
    //     }

    //     .title {
    //         font-size: 12px;
    //         opacity: 80%;
    //         color: #fff;
    //     }
    // }
}</style>